import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";

import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";
import { AddressAutocomplete } from "../../../../pages/auth/parent-registration/SignUp";
import { getTomorrow } from "../../../../pages/SchoolDashboard/Driver/AddSchedule";
import { parseLocalDate } from "../../../../utils";
import CustomDatePicker from "../../../CustomDatePicker";

const initialState = {
  charter_type: "outgoing_trip",
  start_date: "",
  start_time: "",
  end_time: "",
  return_start_time: "",
  return_end_time: "",
  pickup_address: "",
  destination_address: "",
  pickup_lat: "",
  pickup_lng: "",
  dropoff_lat: "",
  dropoff_lng: "",
  reserved_seats: "",
  fare_rate: "",
  notes: "",
};

const OneTime = ({
  onClose,
  selectedVehicle,
  selectedReservation = null,
  isLoading,
  onSubmit,
}) => {
  const tomorrow = getTomorrow();
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [fareRate, setFareRate] = useState("");
  const [totalSeats, setTotalSeats] = useState("");

  const handleModalClose = () => {
    onClose();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "end_time") {
      if (!formData.start_time) {
        setErrors((prev) => ({
          ...prev,
          end_time: t("errors.select_start_time_first"),
        }));
        return;
      }
      if (formData.start_time < value) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      } else {
        setErrors((prev) => ({
          ...prev,
          end_time: t("errors.cannot_select_previous_time"),
        }));
      }
      return;
    }
    if (name === "return_end_time") {
      if (!formData.return_start_time) {
        setErrors((prev) => ({
          ...prev,
          return_end_time: t("errors.select_return_start_time_first"),
        }));
        return;
      }
      if (formData.return_start_time < value) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      } else {
        setErrors((prev) => ({
          ...prev,
          return_end_time: t("errors.cannot_select_previous_time"),
        }));
      }
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    // setErrors((prev) => ({
    //   ...prev,
    //   [name]: "",
    // }));
  };

  // Change Address
  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Parent Address Autocomplete
  const handleParentAddressSelect = (name, address) => {
    const addrs =
      name === "pickup_address"
        ? {
            pickup_address: address.street,
            pickup_lat: address.latitude,
            pickup_lng: address.longitude,
          }
        : {
            destination_address: address.street,
            dropoff_lat: address.latitude,
            dropoff_lng: address.longitude,
          };

    setFormData((prev) => ({
      ...prev,
      ...addrs,
    }));
  };

  // price calculate
  useEffect(() => {
    const startTimeParts = formData.start_time.split(":");
    const endTimeParts = formData.end_time.split(":");
    const startTimeInMinutes =
      parseInt(startTimeParts[0]) * 60 + parseInt(startTimeParts[1]);
    const endTimeInMinutes =
      parseInt(endTimeParts[0]) * 60 + parseInt(endTimeParts[1]);
    let totalMin = endTimeInMinutes - startTimeInMinutes;
    let rate = fareRate / 60;
    let ratePerMin = rate;
    const totalRes = totalMin * ratePerMin;

    if (formData.charter_type === "round_trip") {
      setFormData((prev) => ({ ...prev, fare_rate: totalRes * 2 }));
    } else {
      setFormData((prev) => ({ ...prev, fare_rate: totalRes }));
    }
  }, [
    formData.start_time,
    formData.end_time,
    formData.start_date,
    formData.end_date,
    formData.charter_type,
  ]);

  const handleChangeDate = (date, name) => {
    if (!date) {
      setFormData((prev) => ({ ...prev, [name]: null }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: date }));
  };

  const isRoundTrip = formData.charter_type === "round_trip";

  const validateForm = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (key === "notes") return;
      if (key === "return_start_time" || key === "return_end_time") return;

      if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "")
      ) {
        newErrors[key] = `${t("errors." + key)} ${t("errors.required")}`;
      }
    });

    if (isRoundTrip) {
      if (!formData.return_start_time)
        newErrors.return_start_time = `${t("errors.return_start_time")} ${t("errors.required")}`;
      if (!formData.return_end_time)
        newErrors.return_end_time = `${t("errors.return_end_time")} ${t("errors.required")}`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    toast.dismiss();

    if (formData.reserved_seats > totalSeats) {
      toast.error(t("errors.reserved_seats_exceed"));
      return;
    }

    await onSubmit(formData);
    // setFormData(initialState);
  };

  // for update set data in state
  useEffect(() => {
    if (selectedReservation) {
      setFormData({
        id: selectedReservation?.id,
        booking_type: selectedReservation?.booking_type || "",
        start_date: parseLocalDate(selectedReservation.start_date),

        start_time: selectedReservation?.start_time || "",
        end_time: selectedReservation?.end_time || "",
        return_start_time: selectedReservation?.return_start_time || "",
        return_end_time: selectedReservation?.return_end_time || "",
        charter_type: selectedReservation?.charter_type || "",

        reserved_seats: selectedReservation?.reserved_seats || "",
        fare_rate: Number(selectedReservation?.fare_rate) || "",
        notes: selectedReservation?.notes || "",
        vehicle_id: selectedReservation?.vehicle?.id || "",

        pickup_address: selectedReservation?.pickup_address || "",
        destination_address: selectedReservation?.destination_address || "",
        pickup_lat: selectedReservation?.pickup_lat || "",
        pickup_lng: selectedReservation?.pickup_lng || "",
        dropoff_lat: selectedReservation?.dropoff_lat || "",
        dropoff_lng: selectedReservation?.dropoff_lng || "",
      });
      setTotalSeats(Number(selectedReservation?.vehicle?.seats));
      setFareRate(selectedReservation?.vehicle?.fare_rate);
    }
  }, [selectedReservation]);

  // set inital price
  useEffect(() => {
    if (selectedVehicle) {
      setFormData((prev) => ({
        ...prev,
        vehicle_id: selectedVehicle?.id,
      }));
      setFareRate(selectedVehicle?.fare_rate);
      setTotalSeats(selectedVehicle.seat);
    }
  }, [selectedVehicle]);

  return (
    <>
      {/* <div aria-hidden={formData.booking_type !== "one_time" ? true : false}> */}
      <ul className="form p-0 m-0 d-flex flex-wrap">
        <li className="col-12">
          <CustomDatePicker
            label={`${t("start")} ${t("date")}`}
            selected={formData.start_date}
            onChange={(date) => handleChangeDate(date, "start_date")}
            minDate={tomorrow}
            error={errors.start_date}
            className="formInput"
          />
        </li>
        <li className="col-6">
          <label className="form-label fw-semibold">
            {isRoundTrip ? `${t("outgoing")} ` : ""}
            {t("start")} {t("time")} <span className="text-danger">*</span>
          </label>
          <div className="position-relative">
            <input
              type="time"
              className="formInput"
              name="start_time"
              value={formData?.start_time || ""}
              onChange={handleChange}
            />
          </div>
          {errors?.start_time && (
            <span className="text-danger small">{errors?.start_time}</span>
          )}
        </li>
        <li className="col-6">
          <label className="form-label fw-semibold">
            {isRoundTrip ? `${t("outgoing")} ` : ""}
            {t("end")} {t("time")} <span className="text-danger">*</span>
          </label>
          <div className="position-relative">
            <input
              type="time"
              className="formInput"
              name="end_time"
              value={formData.end_time}
              onChange={handleChange}
            />
          </div>
          {errors?.end_time && (
            <span className="text-danger small">{errors?.end_time}</span>
          )}
        </li>

        {isRoundTrip && (
          <>
            <li className="col-6">
              <label className="form-label fw-semibold">
                {t("return")} {t("start")} {t("time")}{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="position-relative">
                <input
                  type="time"
                  className="formInput"
                  name="return_start_time"
                  value={formData.return_start_time}
                  onChange={handleChange}
                />
              </div>
              {errors?.return_start_time && (
                <span className="text-danger small">
                  {errors?.return_start_time}
                </span>
              )}
            </li>
            <li className="col-6">
              <label className="form-label fw-semibold">
                {t("return")} {t("end")} {t("time")}{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="position-relative">
                <input
                  type="time"
                  className="formInput"
                  name="return_end_time"
                  value={formData.return_end_time}
                  onChange={handleChange}
                />
              </div>
              {errors?.return_end_time && (
                <span className="text-danger small">
                  {errors?.return_end_time}
                </span>
              )}
            </li>
          </>
        )}

        <li className="col-12">
          <label className="form-label fw-semibold">
            {t("reservation")} {t("type")}{" "}
            <span className="text-danger">*</span>
          </label>
          <select
            className="formSelect"
            name="charter_type"
            value={formData.charter_type}
            onChange={handleChange}
          >
            <option value="outgoing_trip">
              {t("outgoing")} {t("trip")}
            </option>
            <option value="return_trip">
              {t("return")} {t("trip")}
            </option>
            <option value="round_trip">
              {t("round")} {t("trip")}
            </option>
          </select>
          {errors?.charter_type && (
            <span className="text-danger small">{errors?.charter_type}</span>
          )}
        </li>

        <li className="col-12">
          <label className="form-label fw-semibold">
            {t("pickup")} {t("address")} <span className="text-danger">*</span>
          </label>
          <AddressAutocomplete
            name="pickup_address"
            value={formData.pickup_address}
            onChange={handleChangeAddress}
            onSelect={(addr) =>
              handleParentAddressSelect("pickup_address", addr)
            }
          />
          {errors?.pickup_address && (
            <span className="text-danger small">{errors?.pickup_address}</span>
          )}
        </li>
        <li className="col-12">
          <label className="form-label fw-semibold">
            {t("destination")} {t("address")}{" "}
            <span className="text-danger">*</span>
          </label>
          <AddressAutocomplete
            name="destination_address"
            value={formData.destination_address}
            onChange={handleChangeAddress}
            onSelect={(addr) =>
              handleParentAddressSelect("destination_address", addr)
            }
          />
          {errors?.destination_address && (
            <span className="text-danger small">
              {errors?.destination_address}
            </span>
          )}
        </li>
        <li className="col-12">
          <label className="form-label fw-semibold">
            {t("reserved")} {t("seats")} <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="formInput"
            name="reserved_seats"
            value={formData?.reserved_seats || ""}
            onChange={handleChange}
          />
          {errors?.reserved_seats && (
            <span className="text-danger small">{errors?.reserved_seats}</span>
          )}
        </li>
        <li className="col-12">
          <label className="form-label fw-semibold">
            {t("fare")} {t("rate")}
          </label>
          <input
            type="text"
            className="formInput"
            value={`$ ${
              formData?.fare_rate ? formData.fare_rate.toFixed(2) : "00.00"
            }`}
            readOnly
          />
        </li>
        <li className="col-12">
          <label className="form-label fw-semibold">{t("Note")}</label>
          <textarea
            name="notes"
            rows={4}
            className="formInput"
            value={formData.notes || ""}
            onChange={handleChange}
            placeholder={`${t("enter")} ${t("notes")}`}
          />
        </li>

        <li className="d-flex col-12">
          <div className="col-6 pe-2 pt-2">
            <Button className="smallBtn full cancel" onClick={handleModalClose}>
              Cancel
            </Button>
          </div>
          <div className="col-6 ps-2 pt-2">
            <Button className="smallBtn full" onClick={handleSubmit}>
              {isLoading ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only p-0"></span>
                </div>
              ) : (
                t("book")
              )}
            </Button>
          </div>
        </li>
      </ul>
    </>
  );
};

export default OneTime;
